module.exports = __webpack_public_path__ + "img/feature_1.661b7302.webp";